import { NavLink, Outlet } from "react-router-dom";
import { Cpu, Users, Activity, Settings as Cog, Globe, LogOut } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Command", icon: Cpu, id: "command" },
  { to: "/omvexis", label: "Omvexis Portal", icon: Globe, id: "omvexis" },
  { to: "/enquiries", label: "Enquiries", icon: Users, id: "enquiries" },
  { to: "/settings", label: "Settings", icon: Cog, id: "settings" },
];

const Clock = () => {
  const [t, setT] = useState(new Date());
  useEffect(() => {
    const i = setInterval(() => setT(new Date()), 1000);
    return () => clearInterval(i);
  }, []);
  return <span data-testid="hud-clock">{t.toLocaleTimeString([], { hour12: false })}</span>;
};

export default function Shell() {
  const nav = NAV;
  const { logout } = useAuth();
  return (
    <div className="relative min-h-screen bg-[#1d0702] text-slate-100">
      <div className="hud-bg" />
      <div className="omx-orbs" aria-hidden="true"><span /><span /><span /><span /><span /><span /></div>
      <header className="sticky top-0 z-30 bg-[#1d0702]/80 backdrop-blur-xl">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-4 flex items-center justify-between gap-4">
          <NavLink to="/" className="flex items-center gap-3 shrink-0" data-testid="brand-logo">
            <span className="w-9 h-9 rounded-xl bg-white flex items-center justify-center overflow-hidden"><img src="/omvexis-logo.png" alt="Omvexis" className="h-7 object-contain" /></span>
            <span className="font-display font-extrabold tracking-[0.3em] text-sm text-white">JARVIS</span>
            <span className="hidden xl:inline text-[10px] uppercase tracking-[0.2em] text-cyan-200/60 border-l border-white/10 pl-3">by Omvexis</span>
          </NavLink>
          <nav className="flex items-center gap-1 rounded-full border border-white/15 bg-white/[0.04] p-1 overflow-x-auto">
            {nav.map(({ to, label, icon: Icon, id }) => (
              <NavLink key={to} to={to} end data-testid={`nav-${id}`}
                className={({ isActive }) => `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200 ${isActive ? "bg-[#ffdcb8] text-[#2b0d02]" : "text-white/80 hover:text-white hover:bg-white/5"}`}>
                <Icon size={15} className="lg:hidden" />
                <span className="hidden lg:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-3 shrink-0">
            <span className="flex items-center gap-2 rounded-full border border-white/15 px-3 py-2 text-xs text-white/80" data-testid="system-status"><Activity size={12} className="text-emerald-400" /><Clock /></span>
            <NavLink to="/" className="rounded-full bg-black px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#2b0d02] transition-colors" data-testid="ask-jarvis-button">Ask Jarvis</NavLink>
            <button onClick={logout} className="rounded-full border border-white/15 p-2.5 text-white/70 hover:text-red-300 transition-colors" aria-label="Sign out" data-testid="logout-button"><LogOut size={15} /></button>
          </div>
        </div>
      </header>
      <main className="relative z-10 max-w-[1500px] mx-auto min-h-screen px-6 lg:px-12 py-10">
        <Outlet />
      </main>
    </div>
  );
}
